import * as Actions from '../actions';
// TODO REFACTOR HERE

const initialState = {

	data:
		[
			{
				service: "nodus-web-api",
				Runing: true,
				CpuPercentUsed: 0,
				MenPrenceUsed: 0,
			},
			{
				service: "system",
				CpuPercentUsed: 0,
				MenPrenceUsed: 0,
				MenTotal: 0,
				diskTotal: 0,
				diskUsedPercent: 0,
			},
		],


};

const DashboardReducer = (state = initialState, action) => {

	switch (action.type) {
		// SET
		case Actions.SET_DASHBOARD: {
			return action.payload;

		}
		// DEFAULT
		default: {
			return state;
		}
	}
};

export default DashboardReducer;
